<template>
    <b-card id="smartTag" class="p-sm-4 my-4">
      <h5 class="card-title pt-2">Bidders</h5>
      <b-form inline>
            <b-form-group>
              <cool-label>
                Select new bidder
                <span
                  v-b-popover.hover.click.right="'Bidder code based on prebid'"><span
                  class="icon icon-Tooltip h5 d-inline align-text-bottom"></span></span>
              </cool-label>
              <b-form-select
                @change="addBidder"
                :options="bidderOptionsList"
                v-model="selectedNewBidder" />
            </b-form-group>
      </b-form>
      <b-form inline v-if="newBidder">
        <b-input-group :prepend="field" v-for="field in Object.keys(newBidder.params)" :key="field" class="mt-3 mr-3 ml-0">
          <b-form-input v-model="newBidder.params[field]"></b-form-input>
        </b-input-group>
      </b-form>
      <b-form-group class="mt-3">
        <b-button variant="primary" @click="saveNewBidder" :disabled="!newBidderValid">Add</b-button>
      </b-form-group>

      <h4 class="mt-5">Enabled Bidders</h4>
      <b-badge v-if="!value.bidders || !value.bidders.length">No enabled bidders yet</b-badge>
      <b-list-group>
        <b-list-group-item v-for="(bidder, index) in value.bidders" key="bidder.bidder + index">
          <b-badge variant="info">{{ bidder.bidder }}</b-badge>
          <span v-for="field in Object.keys(bidder.params)" :key="field" v-if="field !== 'bidder'" class="mx-3">
            <cool-label>{{ field }}</cool-label>
            {{ bidder.params[field] }}
          </span>
          <b-button @click="removeBidder(bidder)" variant="danger" class="float-right btn-sm">
            x
          </b-button>
        </b-list-group-item>
      </b-list-group>
    </b-card>
</template>

<script>
  export default {
    props: {
      value: { required: true },
      serverOnly: { required: false, default: () => false }
    },
    data () {
      return {
        selectedNewBidder: null, // from selection box
        newBidder: null, // temporary object we edit until saved to list
        bidderOptions: [
          { bidder: 'smartrtb', fields: [ "zoneId" ] },
          { bidder: "rubicon", fields: [ "accountId", "siteId", "zoneId" ]},
          { bidder: "sovrn", fields: [ "tagid" ] },
          { bidder: "synacormedia", fields: [ "seatId", "placementId" ]},
          { bidder: "brightcom", fields: [ "publisherId" ]},
          { bidder: "sonobi", fields: [ "placement_id" ]},
          { bidder: "ix", fields: [ "siteId" ]},
          { bidder: 'eplanning', fields: [ 'ci' ] },
          { bidder: 'cedato', fields: [ 'player_id' ]},
          { bidder: 'vidazoo', fields: [ 'cId', 'pId' ]},
          { bidder: 'vidazoo_desktop', fields: [ 'widgetId', 'ecpm' ] },
          { bidder: 'adyoulike', fields: [ 'placement' ] },
          { bidder: '33across', fields: [ 'siteId', 'productId' ]},
          { bidder: 'conversant', fields: [ 'site_id', 'bidfloor', 'tag_id' ]},
          { bidder: 'valueimpression', fields: ['siteId'] },
          { bidder: 'teads', fields: ['pageId', 'placementId']},
          { bidder: 'adplus', fields: [ 'slotId', 'site', 'ecpm' ] },
          { bidder: 'nativo', fields: [ 'ptd', 'ecpm' ] },
          { bidder: 'appnexus', fields: [ 'placementId' ], server: true },
          { bidder: 'appnexus_banner', fields: [ 'placementId' ], server: true },
          { bidder: 'appnexus_video', fields: [ 'placementId' ], server: true },
          { bidder: 'appnexus_native', fields: [ 'placementId' ], server: true },
          { bidder: 'outbrain', fields: [ 'widgetJSId', 'idx' ] },
          { bidder: 'rhythmone', fields: [ 'placementId' ] },
          { bidder: 'onetag', fields: [ 'pubId' ]},
          { bidder: 'onedisplay', fields: [ 'placement', 'network' ] },
          { bidder: 'onemobile', fields: [ 'dcn', 'pos' ] },
          { bidder: 'openx', fields: [ 'platform', 'unit' ] },
          { bidder: 'emx_digital', fields: [ 'tagid' ] },
          { bidder: 'districtmDMX', fields: [ 'placementId' ] },
          { bidder: 'gumgum', fields: [ 'zone' ] },
          { bidder: 'nobid', fields: [ 'siteId', 'placementId' ] },
          { bidder: 'sortable', fields: [ 'tagId', 'siteId' ] },
          { bidder: 'spotx', fields: [ 'channel_id', 'ad_unit' ] },
          { bidder: 'medianet', fields: [ 'cid', 'crid' ] },
          { bidder: 'trion', fields: [ 'pubId', 'sectionId' ]},
          { bidder: 'undertone', fields: [ 'placementId', 'publisherId' ] },
          { bidder: 'triplelift', fields: [ 'inventoryCode' ] },
          { bidder: 'avantis', fields: [ 'ecpm' ] },
          { bidder: 'avantis_floater', fields: [ 'ecpm' ] },
          { bidder: 'avantis_docked', fields: [ 'ecpm' ] },
          { bidder: 'udm', fields: [ 'sid' ] },
          { bidder: 'connectad', fields: [ 'networkId', 'siteId' ] },
          { bidder: 'askmedia', fields: [ 'cid', 'w', 'h', 'ecpm' ] },
          { bidder: 'distroscale', fields: [ 'ecpm' ] },
          { bidder: 'kubient', fields: [ 'zoneid' ] },
          { bidder: 'VAST', fields: [ 'tag', 'bidder', 'ecpm' ] },
          { bidder: 'IMA', fields: [ 'tag', 'bidder', 'ecpm' ] },
          { bidder: 'JSTAG', fields: [ 'tag', 'bidder', 'ecpm' ] },
          { bidder: 'pubmatic', fields: [ 'siteid', 'tagid' ], server: true }
        ]
      }
    },
    methods: {
      addBidder () {
        let nb = this.selectedNewBidder

        let bidder = {
          bidder: nb.bidder,
          params: {}
        }
        for(let field of nb.fields) {
          bidder.params[field] = null
        }

        // our typical global defaults
        let p = bidder.params
        switch (nb.bidder) {
          case 'synacormedia':
            p.seatId = 'smartrtb'
            p.placementId = '85747'
            break
          case 'rubicon':
            p.accountId = '22090'
            break
          case 'eplanning':
            p.ci = '2d1f1'
            break
          case '33across':
            p.productId = 'siab'
            break
          case 'conversant':
            p.secure = 1
            break
          case 'onetag':
            p.pubId = '634a6bb0b06c3e8'
            break
          case 'connectad':
            p.networkId = '10047'
            break
        }

        this.newBidder = bidder
      },
      saveNewBidder () {
        if (!this.value.bidders) {
          this.value.bidders = []
        }

        this.value.bidders.push(this.newBidder)
        this.newBidder = null
      },
      removeBidder (bidder) {
        this.value.bidders.splice(this.value.bidders.indexOf(bidder), 1)
      }
    },
    computed: {
      bidderOptionsList () {
        let list = []

        for (let bidder of this.bidderOptions) {
          if (this.serverOnly === true && bidder.server !== true) {
            continue
          }

          list.push({ text: bidder.bidder, value: bidder })
        }

        return list
      },
      newBidderValid () {
        if (!this.newBidder) {
          return false
        }
        // Makes sure all params are filled out, assume all required for now
        let nb = this.newBidder

        for (let param of Object.keys(nb.params)) {
          if (!nb.params[param] || nb.params[param] === '') {
            switch (nb.bidder) {
              // simple way to implement a few optional parameters
              case 'conversant':
                if (param === 'tag_id' || param === 'bidfloor') break
              case 'nobid':
                if (param === 'placementId') break
                default:
                  return false
            }
          }
        }

        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/PrebidBidders.vue